import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ProductFeaturesTableFeature } from "./product-features-table-feature/product-features-table-feature";
import { translateProductKeyFallbackToCore } from "/services/pricing-features-service";
import { StyledProductFeaturesTableSection } from "./product-features-table-section.scss";
export const ProductFeaturesTableSection = ({ productName, productSection, hideFreeTier, hasFreeTier, isNewPricing, shouldHideBasicTier })=>{
    const { sectionName, features } = productSection;
    const productSectionName = translateProductKeyFallbackToCore({
        productName,
        key: `sections.${sectionName}`
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            sectionName && /*#__PURE__*/ _jsx(StyledProductFeaturesTableSection, {
                className: "feature-section-name",
                isNewPricing: isNewPricing,
                children: /*#__PURE__*/ _jsx("h3", {
                    children: productSectionName
                })
            }),
            features.map((feature)=>/*#__PURE__*/ _jsx(ProductFeaturesTableFeature, {
                    productName: productName,
                    feature: feature,
                    hideFreeTier: hideFreeTier,
                    hasFreeTier: hasFreeTier,
                    isNewPricing: isNewPricing,
                    shouldHideBasicTier: shouldHideBasicTier
                }, feature.featureName))
        ]
    });
};
